import { css } from "../../../styled-system/css";
import { ModalSize } from "./Modal";

export const styles = {
  root: (size: ModalSize, isAnimating: boolean, allowOverflow: boolean) =>
    css({
      maxWidth: size === "short" ? "436px" : size === "medium" ? "616px" : "712px",
      width: "calc(100% - (token(spacing.baseUnit.mobile2) * 2))",
      maxHeight: "calc(100% - (token(spacing.baseUnit.mobile2) * 2))",
      overflow: allowOverflow ? "visible" : "auto",
      padding: "baseUnit.mobile2",
      opacity: isAnimating ? "1" : "0",
      transition: "opacity 0.25s ease-in-out",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      borderRadius: "10px",
      boxShadow: "softBottomLeft",
      zIndex: "popup",
      "& p": {
        fontSize: "body.mouse",
        lineHeight: "body.mouse",
        letterSpacing: "body.mouse",
      },
      tablet: {
        paddingTop: size === "short" ? "baseUnit.mobile2" : "baseUnit.mobile3",
        paddingBottom:
          size === "short" ? "baseUnit.mobile2" : size === "medium" ? "baseUnit.mobile3" : "baseUnit.mobile5",
        paddingX: size === "short" ? "baseUnit.mobile2" : "baseUnit.mobile3",
      },
    }),
  iconButton: () =>
    css({
      position: "absolute",
      top: "0",
      right: "0",
      padding: "12px",
      cursor: "pointer",
      boxSizing: "content-box",
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      _focusVisible: {
        outline: "solid 2px",
        outlineColor: "linkBlue",
      },
      _hover: {
        backgroundColor: "splitterGrey",
      },
      _active: {
        backgroundColor: "backgroundGrey",
      },
      tablet: {
        top: "baseUnit.mobile1",
        right: "baseUnit.mobile1",
      },
    }),
  closeButtonWrapper: () =>
    css({
      position: "absolute",
      right: "baseUnit.mobile2",
      bottom: "baseUnit.mobile2",
      cursor: "pointer",
      boxSizing: "content-box",
      "& button": {
        padding: 0,
        _hover: {
          background: "initial",
          boxShadow: "none",
        },
        _focus: {
          background: "initial",
          boxShadow: "none",
        },
      },
      tablet: {
        bottom: "auto",
      },
    }),
};
